import { deeplinks } from '@teamexos/fit-shared';

// Routes supported by the mobile app but not the web app.
export const mobileOnlyDeepLinks = deeplinks
  .filter((link) => link.mobile && !link.web)
  .map((link) => link.route);
